// Exporta os dados ja carregados na tela (Tabela/Grafico) para CSV, sem
// endpoint novo no backend - o que aparece na tela e' o que se exporta.
export function exportarCsv(nomeArquivo: string, linhas: Array<Record<string, unknown>>): void {
  if (linhas.length === 0) return;

  // Uniao das chaves de TODAS as linhas, nao so' da primeira - linhas
  // pivotadas (estacao+timestamp) podem ter conjuntos de colunas (tags)
  // diferentes entre si quando nem toda estacao reporta toda variavel no
  // mesmo instante.
  const colunas = [...new Set(linhas.flatMap((linha) => Object.keys(linha)))];
  const escapar = (valor: unknown) => {
    const texto = valor === null || valor === undefined ? "" : String(valor);
    return /[",\n]/.test(texto) ? `"${texto.replace(/"/g, '""')}"` : texto;
  };

  const csv = [
    colunas.join(","),
    ...linhas.map((linha) => colunas.map((c) => escapar(linha[c])).join(",")),
  ].join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = nomeArquivo;
  link.click();
  URL.revokeObjectURL(url);
}
